import Link from './Link';

// export types
export type { LinkProps } from './Link';

// export components
export { Link };
export default Link;
